const locationTypes = {
	LIST: {
		REQUEST: 'LOCATION_LIST_REQUEST',
		SUCCESS: 'LOCATION_LIST_SUCCESS',
		FAILURE: 'LOCATION_LIST_FAILURE',
		CLEAR: 'LOCATION_LIST_CLEAR',
	},

	NESHAN_POSITION: {
		REQUEST: 'LOCATION_NESHAN_POSITION_REQUEST',
		SUCCESS: 'LOCATION_NESHAN_POSITION_SUCCESS',
		FAILURE: 'LOCATION_NESHAN_POSITION_FAILURE',
		CLEAR: 'LOCATION_NESHAN_POSITION_CLEAR',
	},
	POINT_TO_ADDRESS: {
		REQUEST: 'LOCATION_POINT_TO_ADDRESS_REQUEST',
		SUCCESS: 'LOCATION_POINT_TO_ADDRESS_SUCCESS',
		FAILURE: 'LOCATION_POINT_TO_ADDRESS_FAILURE',
		CLEAR: 'LOCATION_POINT_TO_ADDRESS_CLEAR',
	},
	POINT_TO_LOCATION: {
		REQUEST: 'LOCATION_POINT_TO_LOCATION_REQUEST',
		SUCCESS: 'LOCATION_POINT_TO_LOCATION_SUCCESS',
		FAILURE: 'LOCATION_POINT_TO_LOCATION_FAILURE',
		CLEAR: 'LOCATION_POINT_TO_LOCATION_CLEAR',
	},
	LOCATION_GENERAL: {
		REQUEST: 'LOCATION_GENERAL_REQUEST',
		FAILURE: 'LOCATION_GENERAL_FAILURE',
		RESET: 'LOCATION_GENERAL_RESET',
	},
	LOCATION_PROVINCE: {
		SUCCESS: 'LOCATION_PROVINCE_SUCCESS',
		CLEAR: 'LOCATION_PROVINCE_CLEAR',
	},

	LOCATION_CITY: {
		SUCCESS: 'LOCATION_CITY_SUCCESS',
		CLEAR: 'LOCATION_CITY_CLEAR',
	},

	LOCATION_DISTRICT: {
		SUCCESS: 'LOCATION_DISTRICT_SUCCESS',
		CLEAR: 'LOCATION_DISTRICT_CLEAR',
	},

	LOCATION_AREA: {
		SUCCESS: 'LOCATION_AREA_SUCCESS',
		CLEAR: 'LOCATION_AREA_CLEAR',
	},
};

export default locationTypes;
